import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Grid } from "../../core/components/grid";
import { Helper } from "../../core/util/helper";
import { AppHelper } from "../../appHelper";
import { Config } from "../../core/config/config";
import { MainGroupLanguageDependentParameters, MainGroupEntity } from "./EditMainGroup";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { Label, LabelProps } from "../../core/components/label";
import { ComponentHelper } from "../../core/util/componentHelper";
import React from "react";
export default class MainGroupGrid extends React.Component<MainGroupGridProps, MainGroupGridState>{
    common = new AppHelper();
    gridOptions: {} = null;
    private _translations: {};
    private _gridDataAreFilled: boolean;
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._checkLanguageDependentParameters();
                    this._updateEntity();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };

    constructor(props) {
        super(props);
        this.gridOptions = this.props.context.translationsGridOptions;
        this._translations = this.props.context.translations;
        this._gridDataAreFilled = false;
        this._setEvents();
        this.state = { dialogOpen: false, selectedValue: null };
    }
    
    private _updateEntity = (newName: string = null) => {
        let values = this.props.value;
        for (let i = 0; i < values.length; i++) {
            if (newName == null) {
                if (values[i].Language.Id == this.state.selectedValue.Language.Id) {
                    values[i] = this.state.selectedValue;
                    break;
                }
            } else {
                if (newName == "") {
                    values[i].Name = newName;
                } else {
                    if (!Helper.hasValue(values[i].Name) || values[i].Name == "") {
                        values[i].Name = newName;
                    }
                }
            }
        }
        let newEntity = this.props.entity;
        newEntity.LanguageDependentParameters = values;
        Helper.updateEntity(this.props.entity, newEntity);
        if (newName != null) {
            this.setState({});
        }
        $(window).trigger("MainGroupEntityChanged", { update: true });
    }

    private _updateAndOrderLanguages = () => {
        let newEntity = this.props.entity;
        let values = newEntity.LanguageDependentParameters;
        values.sort((a, b) => {
            if (a.Language.Id < b.Language.Id) {
                return -1;
            } else if (a.Language.Id > b.Language.Id) {
                return 1;
            } else {
                return 0;
            }
        });
        newEntity.LanguageDependentParameters = values;
        Helper.updateEntity(this.props.entity, newEntity);
        this.setState({});
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createLanguageLabel()}
                        {this._createNameTextBox()}
                        {this._createDescriptionTextBox()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createLanguageLabel = () => {
        let props: LabelProps = this._factory.getDefaultLabelProps();
        if (Helper.hasValue(this.state.selectedValue)) {
            props.value = this.state.selectedValue.Language.LanguageName;
        }
        return (
            <FieldInstance label={this._translations["Sprachen.Sprache"]} noHover={true} >
                <Label {...props} />
            </FieldInstance>
        );
    }

    private _createNameTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        if (Helper.hasValue(this.state.selectedValue)) {
            props.value = Helper.getValueOrDefault(this.state.selectedValue.Name, "");
        }

        props.field.maxLength = this.props.field.maxLength ?? 30;
        props.onChange = (field: { model: string, name: string }, value: any) => {

            let newSelectedValue = this.state.selectedValue;
            newSelectedValue.Name = value;
            this.setState({ selectedValue: newSelectedValue });

        }
        return (
            <FieldInstance label={this._translations["Standard.Name"]} noHover={true}>
                <TextBox {...props}/>
            </FieldInstance>            
            );
    }

    private _createDescriptionTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        if (Helper.hasValue(this.state.selectedValue)) {
            props.value = Helper.getValueOrDefault(this.state.selectedValue.Description, "");
        }

        props.field.maxLength = 40;
        props.onChange = (field: { model: string, name: string }, value: any) => {

            let newSelectedValue = this.state.selectedValue;
            newSelectedValue.Description = value;
            this.setState({ selectedValue: newSelectedValue });

        }
        return (
            <FieldInstance label={this._translations["Standard.Beschreibung"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: MainGroupLanguageDependentParameters) => {        
        if (type == ToolBarStandardButtonType.EDIT) {
            this._openDialog(dataItem);
        }
    }

    private _openDialog = (dataItem: MainGroupLanguageDependentParameters) => {
        this.setState({ dialogOpen: true, selectedValue: dataItem });
    }

    private _checkSelectedItem = () => {
        if (Helper.hasValue(this.state.selectedValue)) {
            return ((this.state.selectedValue.Name != "") && (this.state.selectedValue.Name != null))
        } else {
            return false;
        }
    }

    private _checkLanguageDependentParameters = () => {
        let sub: boolean = true;
        for (let i = 0; i < this.props.entity.LanguageDependentParameters.length; i++) {
            if (Helper.isNullOrEmpty(this.props.entity.LanguageDependentParameters[i].Name)) {
                sub = false;
                break;
            }
        }
        this._gridDataAreFilled = sub;
        this.setState({});
    }
  
    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "likeUserLanguage", enabled: (!Helper.isNullOrEmpty(this.props.entity.Name) && !this._gridDataAreFilled), caption: Helper.getValueOrDefault(this._translations["WebSMS.UserSettings.MainGroup.FillWithUser2"], ""), autoEnabledOnRecordSelected: false, iconClass: "far fa-user" 
        });
        customButtons.push({
            id: "likeSelectedLanguage", enabled: (this._checkSelectedItem() && !this._gridDataAreFilled), caption: this._translations["WebSMS.UserSettings.MainGroup.FillWithSelect2"], autoEnabledOnRecordSelected: true, iconClass: "fas fa-language"
        });
        customButtons.push({
            id: "deleteNames", enabled: true, caption: this._translations["WebSMS.UserSettings.MainGroup.DeleteNames"], autoEnabledOnRecordSelected: false, iconClass: "fas fa-ban"
        });

        let grid = (
            <Grid data={this.props.entity.LanguageDependentParameters} options={this.gridOptions} id="GeneralSettings_ResourcePlanning_MainGroupsGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                customButtons={customButtons} onClickCustomButton={this.handleClickCustomButton}
                onSelectionChanged={this.handleSelectionChanged}/>                
        );
        return (grid)
    }

    handleSelectionChanged = (dataItem: MainGroupLanguageDependentParameters) => { 
        this.setState({ selectedValue: dataItem });
    }

    handleClickCustomButton = (id: string, dataItem: MainGroupLanguageDependentParameters, dataItems: Array<any>) => {
        let newName: string = null;
        switch (id) {
            case ("likeUserLanguage"):
                if (this.props.entity.Name != "")
                    this._gridDataAreFilled = true;
                    newName = this.props.entity.Name;
                break;
            case ("likeSelectedLanguage"):
                if (dataItem.Name != "")
                    this._gridDataAreFilled = true;
                    newName = dataItem.Name;
                break;
            case ("deleteNames"):
                this._gridDataAreFilled = false;
                newName = "";
                break;
        }
        if (Helper.hasValue(newName)){
            this._updateEntity(newName);
        }
    }

    componentDidMount() {
        this._checkLanguageDependentParameters();
    }

    private _setEvents = () => {
        $(window).on("AddLanguageToMainGroup", (e, d) => {
            this._updateAndOrderLanguages();
        });

    }

    render() {
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen?this._createDialog():null;
        return (
            <>
                {grid}
                {dialog}
            </>
        );
    }
}

interface MainGroupGridProps {
    context: any;
    entity: MainGroupEntity;
    value: MainGroupLanguageDependentParameters[];
    field: {
        maxLength: number
    }
}

interface MainGroupGridState {
    dialogOpen: boolean;
    selectedValue: MainGroupLanguageDependentParameters;
}